import {Button as ButtonBase, StyleProps, Text} from '@miro-site/core'
import type {ButtonProps} from '@miro-site/core'

import React from 'react'
import styled from 'styled-components'

import {Categories, Close} from '../../icons/Icons'

interface BtnProps extends ButtonProps {
  isOpened?: boolean
  isSearchActive: boolean
  onClick?: React.MouseEventHandler<HTMLElement>
  $styles?: StyleProps
  onKeyDown?: (event: React.KeyboardEvent<HTMLDivElement>) => void
}

const Button = styled(ButtonBase)`
  display: flex;
  justify-content: flex-start;
  align-items: center;

  &:hover {
    color: ${({theme}) => theme.colors.primaryBlue};

    ${Text} {
      color: ${({theme}) => theme.colors.primaryBlue};
    }
  }

  &:focus {
    ${({theme}) => theme.normalizeStyles({...theme.focus.outlines.default})}
  }
`

const CategoryButton = React.forwardRef<HTMLAnchorElement | HTMLButtonElement, BtnProps>(
  ({children, isOpened, isSearchActive, ...props}, ref) => {
    return (
      <Button
        data-track-id="category-menu-button"
        $buttonType="secondary"
        $size="small"
        ref={ref}
        $styles={{
          position: isSearchActive ? 'absolute' : 'relative',
        }}
        {...props}
      >
        {isOpened ? <Close width={20} height={20} /> : <Categories width={20} height={20} />}
        <Text as="span" $ml={7} $variant="p2">
          {children}
        </Text>
      </Button>
    )
  },
)

CategoryButton.displayName = 'CategoryButton'

export default CategoryButton
